import { TESTIMONIALS } from "../types/actions";

const initialState = {
	testimonialsResult: [],
	countries: {},
	replacements: {},
	testimonialImageList: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case TESTIMONIALS.GET_TESTIMONIALS:
			return {
				...state,
				testimonialsResult: action.payload
			};
		case TESTIMONIALS.GET_TESTIMONIALS_DETAILS:
			return {
				...state,
				testimonialDetail: action.payload
			};
		case TESTIMONIALS.ADD_TESTIMONIAL:
			return {
				...state,
				testimonialsResult: action.payload
			};
		case TESTIMONIALS.GET_COUNTRIES:
			return {
				...state,
				countries: action.payload
			};
		case TESTIMONIALS.GET_REPLACEMENTS:
			return {
				...state,
				replacements: action.payload
			};
		case TESTIMONIALS.SUBMIT_TESTIMONIAL:
			return {
				...state,
				testimonialsResult: action.payload
			};
		case TESTIMONIALS.GET_TESTIMONIAL_IMAGES:
			return {
				...state,
				testimonialImageList: action.payload
			};
		case TESTIMONIALS.ADD_TESTIMONIAL_IMAGES:
			return {
				...state,
				testimonialImageList: action.payload
			};
		case TESTIMONIALS.DELETE_IMAGE:
			return {
				...state,
				testimonialImageList: action.payload
			};
		case TESTIMONIALS.EDIT_TESTIMONIAL:
			return {
				...state,
				testimonialImageList: action.payload
			};
		default:
			return state;
	}
};
